import { createStore, applyMiddleware } from "redux";
import { createEpicMiddleware } from "redux-observable";
import rootEpic from "./rootEpic";
import rootReducer from "./rootReducer";

import { composeWithDevTools } from "redux-devtools-extension";

const epicMiddleware = createEpicMiddleware();

// const middlewares = [epicMiddleware];

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(epicMiddleware)),
);

epicMiddleware.run(rootEpic);

export default store;
